import React from "react";
import { Box } from "@mui/material";
import { useGetDividendsPerYear } from "@bn/api/apiv1";
import { LoadingPlaceHolder } from "@components";
import { SecurityFundamentalsByIsin } from "./components/SecurityFundamentals/SecurityFundamentalsByIsin";
import { FundFundamentalsByIsin } from "./components/FundFundamentals/FundFundamentalsByIsin";

export interface Props {
  isin: string;
  securityType?: string;
  quoteProvider?: string;
  tickerSymbol?: string;
  currency?: string;
}

export const FundamentalsPageByIsin = ({
  isin,
  securityType,
  quoteProvider,
  tickerSymbol,
  currency,
}: Props) => {
  // Same query key as DividendsChart, so this shares its result rather than
  // firing a second request. Only used to decide whether the card is rendered
  // at all — an empty dividends chart is not worth a card.
  const { data, isLoading } = useGetDividendsPerYear(
    { isin, currency, predictNumberOfYears: 2 },
    { enabled: !!isin }
  );

  if (isLoading) {
    return (
      <Box pt={6}>
        <LoadingPlaceHolder />
      </Box>
    );
  }

  const areDividendsPresent = (data?.dividendsPerYear?.length ?? 0) > 0;
  const isFund = securityType === "21_fund" || securityType === "22_etf";

  return isFund ? (
    <FundFundamentalsByIsin
      isin={isin}
      currency={currency}
      areDividendsPresent={areDividendsPresent}
    />
  ) : (
    <SecurityFundamentalsByIsin
      isin={isin}
      quoteProvider={quoteProvider}
      tickerSymbol={tickerSymbol}
      currency={currency}
      isSecurityStock={securityType === "11_stock"}
      areDividendsPresent={areDividendsPresent}
    />
  );
};
